var map = {
	"./comprehension_locked_crown.svg": 126,
	"./evennumbers_locked_crown.svg": 127,
	"./letterjumble_locked_crown.svg": 128,
	"./lettermixup_locked_crown.svg": 129,
	"./numbersearch_locked_crown.svg": 130,
	"./numbersinput_locked_crown.svg": 131,
	"./numberswarmup_locked_crown.svg": 132,
	"./powerreader_locked_crown.svg": 133,
	"./schulteletters_locked_crown.svg": 134,
	"./schultemix_locked_crown.svg": 135,
	"./schultenumbers_locked_crown.svg": 136,
	"./sentencesinput_locked_crown.svg": 137,
	"./sentenceswarmup_locked_crown.svg": 138,
	"./textsearch_locked_crown.svg": 139,
	"./wordpairs_locked_crown.svg": 140,
	"./wordsearch_locked_crown.svg": 141,
	"./wordsinput_locked_crown.svg": 142,
	"./wordswarmup_locked_crown.svg": 143,
	"./wpmtest_locked_crown.svg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;